import { render, staticRenderFns } from "./_play-area.vue?vue&type=template&id=2bcc5ef3&scoped=true&"
import script from "./_play-area.vue?vue&type=script&lang=js&"
export * from "./_play-area.vue?vue&type=script&lang=js&"
import style0 from "./_play-area.vue?vue&type=style&index=0&id=2bcc5ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc5ef3",
  null
  
)

export default component.exports